import Jumbotron from '@/components/Jumbotron';
import Navigation from '@/components/Navigation/Navigation';
import SideBar from '@/components/Navigation/Sidebar';
import UserService from '@/services/UserService';
import PasswordChange from '@/components/forms/PasswordChange';
import WatchVideo from '@/components/video-list/WatchVideo';
import { bus } from '@/eventBus';
export default {
  name: 'Default',
  components: {
    Navigation,
    Jumbotron,
    SideBar,
    PasswordChange,
    WatchVideo
  },
  data() {
    return {
      loggedIn: false,
      year: null,
      network: null,
      video: null,
      sidebarCollapsed: false
    };
  },
  computed: {
    brandImage() {
      if (!this.network) return null;
      return this.network.profileimage_display || this.network.logoimage_display || null;
    }
  },
  created() {
    this.init();
    bus.$on('loggedIn', () => {
      this.init();
    });
    bus.$on('loggedOut', () => {
      this.init();
    });
    bus.$on('videoSelected', video => {
      this.video = null;
      this.$nextTick(() => {
        this.video = video;
      });
    });
    bus.$on('clearVideo', () => {
      this.video = null;
    });
    this.year = new Date().getFullYear();
  },
  mounted() {
    bus.$on('scrollToTop', () => {
      this.$nextTick(() => {
        if (this.$refs.videoplayer && this.$refs.videoplayer.$el) {
          this.$refs.videoplayer.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  },
  methods: {
    init() {
      const userinfo = UserService.getStorage('user');
      this.loggedIn = !!(userinfo && userinfo.apikey !== null);
      const net = UserService.getStorage('network');
      if (net && net.id > 0) {
        this.network = net;
      }
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    clearVideo() {
      this.video = null;
    },
    handleWatchFavoriteUpdate({
      id,
      favorite
    }) {
      if (this.video && this.video.id === id) {
        this.video = {
          ...this.video,
          favorite
        };
      }
      bus.$emit('videoFavoriteUpdated', {
        id,
        favorite
      });
    }
  }
};